(function() {
  const root = document.getElementById('offcanvas-root');
  if (!root) return;

  const panel = root.querySelector('.offcanvas__panel');
  let lastFocused = null;

  function openPanel() {
    console.log('open');
    if (root.classList.contains('is-open')) return;
    lastFocused = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    panel.focus();
    document.addEventListener('keydown', onKeydown);
  }

  function closePanel() {
    console.log('clkos');
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.removeEventListener('keydown', onKeydown);
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  function onKeydown(e) {
    if (e.key === 'Escape') closePanel();
  }

  // Close on overlay / close button
  root.querySelector('.offcanvas__overlay')?.addEventListener('click', closePanel);
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-offcanvas-close]')) { e.preventDefault(); closePanel(); }
  });

  // Trigger: ONLY open when clicking the menu item named "Customize"
  // Tip: In your Navigation, set the "Customize" link to "#customize" (recommended) or "/customize".
  function isCustomizeLink(a) {
    if (!a) return false;
    const text = (a.textContent || '').trim().toLowerCase();
    const href = (a.getAttribute('href') || '').trim().toLowerCase();
    return text === 'customize' || href === '#customize' || href === '/customize' || href === '/pages/customize';
  }

  document.addEventListener('click', (e) => {
    const a = e.target.closest('a');
    if (!a) return;
    if (isCustomizeLink(a)) {
      e.preventDefault(); // don’t navigate away
      openPanel();
    }
  });

  // Optional: if someone visits with #customize in the URL, open it automatically
  if (location.hash.toLowerCase() === '#customize') {
    openPanel();
  }
})();
